import * as React from 'react';
import { PriceType } from "../../../classes/price-type";
import { IOption, SeatingOptionGroup } from '../../../classes/seating-option';
import { IExchangeTicket } from '../../../classes/ticket-exchange';
import PriceRange from '../../../common/filters/price-range';
import { IPriceRangeModel } from '../../../filter/reducers/filter-reducers';
import { formatString } from '../../../helpers/string-format';
import { IAppSettingsModel } from '../../../reducers/fetch-settings-reducer';
import PriceTypeFilter from './price-type-filter';
import LevelSelect from './level-select';
import { Level } from '../../../classes/level';
import { CartSeat } from '../../../classes/seat';
import { IAppState } from '../../../reducers/index';
import { toggleSeatmapFilters } from '../../../seatmap/actions/seatmap-actions';
import { convertNumberListToString } from '../../../helpers/array-helpers';
import PerformanceSelect from './performance-select';
import SpecialSeatingFilter from './special-seating-filter';
import isEqual from 'react-fast-compare';
import { ItemType } from '../../../classes/item-type';

interface IFiltersOverlayProps {
    appSettings: IAppSettingsModel;
    additionalSeatingOptions: Array<SeatingOptionGroup>;
    selectedSeatingOptions: Array<SeatingOptionGroup>;
    onPriceRangeClear: (minPrice: number, maxPrice: number) => any;
    onSelectMinPrice: (number) => any;
    onPriceTypeToggle: (selectedOptions: IOption[]) => any;
    onSpecialSeatingToggle: (selectedOptions: IOption[]) => any;
    onLevelSelectOpenToggle: () => any;
    onPriceTypeFilterOpenToggle: () => any;
    onSelectMaxPrice: (number) => any;
    priceRangeModel: IPriceRangeModel;
    startingMinPrice: number;
    startingMaxPrice: number;
    activeExchangeTickets: Array<IExchangeTicket>;
    showComponent: boolean;
    priceTypes: Array<PriceType>;
    selectedPriceTypes: Array<PriceType>;
    showLevelSelectFilter: boolean;
    levelSelectFilterOpen: boolean;
    showPerformanceSelectFilter: boolean;
    openPriceTypeFilter: boolean;
    showPriceRangeFilter: boolean;
    showPriceTypeFilter: boolean;
    showSpecialSeatingFilter: boolean;
    dispatch: any;
    levels: Array<Level>;
    currentSeatmapId: string;
    cartSeats: Array<CartSeat>;
    onLevelSelectModalOpen: () => any;
    seatmapFiltersIsOpen: boolean;
    seatmapFiltersText: string;
}

interface IFiltersOverlayState {
    openPriceRangeFilter: boolean;
    openPerformanceSelectFilter: boolean;
    openSpecialSeatingFilter: boolean;
}

class FiltersOverlay extends React.Component<IFiltersOverlayProps, IFiltersOverlayState> {
    constructor(props) {
        super(props);

        this.state = {
            openPriceRangeFilter: false,
            openPerformanceSelectFilter: false,
            openSpecialSeatingFilter: false
        }
    }

    shouldComponentUpdate(nextProps: IFiltersOverlayProps, nextState: IFiltersOverlayState) {
        return this.props.showComponent != nextProps.showComponent
            || this.props.selectedPriceTypes.length !== nextProps.selectedPriceTypes.length
            || this.props.selectedSeatingOptions.length !== nextProps.selectedSeatingOptions.length
            || !isEqual(
                { priceTypes: this.props.priceTypes, selectedPriceTypes: this.props.selectedPriceTypes },
                { priceTypes: nextProps.priceTypes, selectedPriceTypes: nextProps.selectedPriceTypes })
            || this.props.showLevelSelectFilter != nextProps.showLevelSelectFilter
            || this.props.levelSelectFilterOpen != nextProps.levelSelectFilterOpen
            || this.props.openPriceTypeFilter != nextProps.openPriceTypeFilter
            || this.state.openPriceRangeFilter != nextState.openPriceRangeFilter
            || this.state.openSpecialSeatingFilter != nextState.openSpecialSeatingFilter
            || this.state.openPerformanceSelectFilter != nextState.openPerformanceSelectFilter
            || this.props.priceRangeModel.lowerRangeLimit !== nextProps.priceRangeModel.lowerRangeLimit
            || this.props.priceRangeModel.upperRangeLimit !== nextProps.priceRangeModel.upperRangeLimit
            || this.props.showSpecialSeatingFilter !== nextProps.showSpecialSeatingFilter;
    }

    _togglePriceRangeFilter() {
        this.setState({
            openPriceRangeFilter: !this.state.openPriceRangeFilter
        })
    }

    _togglePerformanceSelectFilter() {
        this.setState({
            openPerformanceSelectFilter: !this.state.openPerformanceSelectFilter
        })
    }

    _toggleSpecialSeatingFilter() {
        this.setState({
            openSpecialSeatingFilter: !this.state.openSpecialSeatingFilter
        })
    }

    _toggleSeatmapFilters(evt) {
        evt.preventDefault();

        this.props.dispatch(toggleSeatmapFilters());
    }

    handleClickOutside = evt => {
        if (this.props.showComponent) {
            this.props.dispatch(toggleSeatmapFilters());
        }
    };

    render() {
        const useTag = `<use xlink:href="#icon-arrow-down" />`;
        const xSvg = `<svg class="close-filters-icon"><use xlink:href="#icon-close" /></svg>`;

        return (
            <div className="overlay-section">
                <div className="overlay-section-header">
                    <button type="button" className="sidebar-section-toggle" onClick={(evt) => this._toggleSeatmapFilters(evt)} aria-expanded={this.props.showComponent}>
                        <h2 className="heading-general" tabIndex={-1}>{this.props.seatmapFiltersText}</h2>
                        <div dangerouslySetInnerHTML={{ __html: xSvg }} ></div>
                    </button>

                </div>

                {this.props.showPerformanceSelectFilter ?
                    <div className="overlay-filter-section">
                        <p className="caption-paragraph">
                            <button aria-expanded={this.state.openPerformanceSelectFilter} className="filter-title" onClick={this._togglePerformanceSelectFilter.bind(this)}>
                                {this.props.appSettings.filterDateAndTimeTitle}
                                <svg className={"filters-section-heading-toggles-icon" + (this.state.openPerformanceSelectFilter ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                            </button>
                        </p>
                        <div hidden={!this.state.openPerformanceSelectFilter}>
                            <PerformanceSelect currentPerformanceId={this.props.appSettings.itemId}
                                productionPerformances={this.props.appSettings.productionPerformances}
                                legend={this.props.appSettings.filterDateAndTimeTitle}
                            />
                        </div>
                    </div>
                    : null}

                {this.props.showLevelSelectFilter ?
                    <div className="overlay-filter-section">
                        <p className="caption-paragraph">
                            <button aria-expanded={this.props.levelSelectFilterOpen} className="filter-title" onClick={this.props.onLevelSelectOpenToggle.bind(this)}>
                                {this.props.appSettings.levelsHeading}
                                <svg className={"filters-section-heading-toggles-icon" + (this.props.levelSelectFilterOpen ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                            </button>
                        </p>
                        <div hidden={!this.props.levelSelectFilterOpen}>
                            <LevelSelect {...this.props.appSettings}
                                isExchange={this.props.appSettings.itemType === ItemType.Exchange}
                                exchangeFreeLabel={this.props.appSettings.exchangeFreeLabel}
                                dispatch={this.props.dispatch}
                                levels={this.props.levels}
                                cartSeats={this.props.cartSeats}
                                displaySeatFee={this.props.appSettings.displaySeatFee}
                                currentSeatmapId={this.props.currentSeatmapId}
                                onLevelSelectModalOpen={this.props.onLevelSelectModalOpen}
                                levelAvailableCountMessage={this.props.appSettings.levelAvailableCountMessage}
                                selectedPriceTypeIdsString={convertNumberListToString(this.props.priceTypes.filter(pt => pt.selectedQuantity > 0).map(pt => pt.priceTypeId))}
                                selectedLevelString={this.props.levels.filter(level => {
                                    return level.selected;
                                }).map(level => {
                                    return level.levelNumber;
                                }).toString()}
                                legend={this.props.appSettings.levelsHeading}
                            />

                        </div>
                    </div>
                    : null}

                {this.props.showPriceRangeFilter ?
                    <div className="overlay-filter-section">
                        <p className="caption-paragraph">
                            <button aria-expanded={this.state.openPriceRangeFilter} className="filter-title" onClick={this._togglePriceRangeFilter.bind(this)}>
                                {this.props.appSettings.seatmapPriceRangeFilterHeader}
                                <svg className={"filters-section-heading-toggles-icon" + (this.state.openPriceRangeFilter ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                            </button>
                        </p>
                        <div hidden={!this.state.openPriceRangeFilter}>
                            <PriceRange {...this.props.appSettings}
                                {...this.props.priceRangeModel}
                                onPriceRangeClear={this.props.onPriceRangeClear}
                                onSelectMaxPrice={this.props.onSelectMaxPrice}
                                onSelectMinPrice={this.props.onSelectMinPrice}
                                startingMinPrice={this.props.startingMinPrice}
                                startingMaxPrice={this.props.startingMaxPrice}
                                showClearButton={false}
                                showTitle={false}
                                titleText={this.props.appSettings.seatmapPriceRangeFilterHeader}>
                            </PriceRange>
                        </div>
                    </div>
                    : null
                }

                {
                    (this.props.appSettings.combinePriceTypeSpecialSeatingFilters && (this.props.showSpecialSeatingFilter || this.props.showPriceTypeFilter)) ?
                        <div className="overlay-filter-section overlay-filter-section-last">
                            <p className="caption-paragraph">
                                <button aria-expanded={this.props.openPriceTypeFilter} className="filter-title" onClick={this.props.onPriceTypeFilterOpenToggle.bind(this)}>
                                    {this.props.appSettings.seatmapTicketTypeFilterHeader}
                                    <svg className={"filters-section-heading-toggles-icon" + (this.props.openPriceTypeFilter ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                                </button>
                            </p>
                            <div hidden={!this.props.openPriceTypeFilter}>
                                {
                                    this.props.showPriceTypeFilter ?
                                        <PriceTypeFilter onPriceTypeToggle={this.props.onPriceTypeToggle} priceTypes={this.props.priceTypes}
                                            selectedPriceTypeIds={this.props.selectedPriceTypes.map(pt => pt.priceTypeId.toString())}
                                            description={this.props.appSettings.seatmapTicketTypeFilterInstructions}
                                            allTicketsText={this.props.appSettings.seatmapTicketTypeAllTicketsLabel}
                                            singleFilter={false}
                                            legend={this.props.appSettings.seatmapTicketTypeFilterHeader}
                                        />
                                        : null
                                }
                                {
                                    this.props.showSpecialSeatingFilter ?
                                        <SpecialSeatingFilter onSpecialSeatingToggle={this.props.onSpecialSeatingToggle}
                                            additionalSeatingOptions={this.props.additionalSeatingOptions}
                                            selectedSpecialSeatingIds={this.props.selectedSeatingOptions.map(option => option.id)}
                                            description={this.props.appSettings.seatmapTicketTypeFilterInstructions}
                                            allTicketsText={this.props.appSettings.seatmapTicketTypeAllTicketsLabel}
                                            singleFilter={false}
                                        />
                                        : null
                                }
                            </div>
                        </div> :
                        (
                            <>
                                {
                                    this.props.showPriceTypeFilter && this.props.showComponent ?
                                        <div className="overlay-filter-section overlay-filter-section-last">
                                            <p className="caption-paragraph">
                                                <button aria-expanded={this.props.openPriceTypeFilter} className="filter-title" onClick={this.props.onPriceTypeFilterOpenToggle.bind(this)}>
                                                    {this.props.appSettings.seatmapTicketTypeFilterHeader}
                                                    <svg className={"filters-section-heading-toggles-icon" + (this.props.openPriceTypeFilter ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                                                </button>
                                            </p>
                                            <div hidden={!this.props.openPriceTypeFilter}>
                                                <PriceTypeFilter onPriceTypeToggle={this.props.onPriceTypeToggle} priceTypes={this.props.priceTypes}
                                                    selectedPriceTypeIds={this.props.selectedPriceTypes.map(pt => pt.priceTypeId.toString())}
                                                    description={this.props.appSettings.seatmapTicketTypeFilterInstructions}
                                                    allTicketsText={this.props.appSettings.seatmapTicketTypeAllTicketsLabel}
                                                    singleFilter={true}
                                                    legend={this.props.appSettings.seatmapTicketTypeFilterHeader}
                                                />
                                            </div>
                                        </div>
                                        : null
                                }
                                {
                                    this.props.showSpecialSeatingFilter && this.props.showComponent ?
                                        <div className="overlay-filter-section overlay-filter-section-last">
                                            <p className="caption-paragraph">
                                                <button aria-expanded={this.state.openSpecialSeatingFilter} className="filter-title" onClick={this._toggleSpecialSeatingFilter.bind(this)}>
                                                    {this.props.appSettings.filterAdditionalSeatingOptionsTitle}
                                                    <svg className={"filters-section-heading-toggles-icon" + (this.state.openSpecialSeatingFilter ? " toggled" : "")} aria-hidden="true" dangerouslySetInnerHTML={{ __html: useTag }} />
                                                </button>
                                            </p>
                                            <div hidden={!this.state.openSpecialSeatingFilter}>
                                                <SpecialSeatingFilter onSpecialSeatingToggle={this.props.onSpecialSeatingToggle}
                                                    additionalSeatingOptions={this.props.additionalSeatingOptions}
                                                    selectedSpecialSeatingIds={this.props.selectedSeatingOptions.map(option => option.id)}
                                                    description={this.props.appSettings.seatmapTicketTypeFilterInstructions}
                                                    allTicketsText={this.props.appSettings.seatmapTicketTypeAllTicketsLabel}
                                                    singleFilter={true}
                                                />
                                            </div>
                                        </div>
                                        : null
                                }
                            </>)
                }


            </div>
        )
    }
}

export default FiltersOverlay;